<template>
  <div v-if="!discharges.length">
  </div>
  <section class="content">
    <div class="d-flex justify-content-end justify-content-between">
      <div class="w-100" v-if="!discharges.length" >
        <EmptyListMessage />
      </div>
      <div class="d-flex w-100 justify-content-end mb-4 actions">
        <div v-if="!isReadonly" class="d-flex justify-content-end mb-4 actions">
          <button-component class="width-auto" @click="addCard()">Создать</button-component>
          <button-component class="mx-2 width-auto"  @click="importXml()">Загрузить из XML</button-component>
        </div>
      </div>

    </div>
  <div v-if="discharges.length" style="overflow: auto">
    <table class="table-custom">
      <thead>
      <tr>
        <th rowspan="2"></th>
        <th rowspan="2">Идентификатор</th>
        <th rowspan="2">Время формирования</th>
        <th colspan="3" class="text-center">Реквизиты документа</th>
        <th rowspan="2">Печатная версия</th>
      </tr>
      <tr>
        <th>Номер</th>
        <th>Дата</th>
        <th>Срок действия</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in discharges" v-on:dblclick="viewCard(item.id)">
        <td><menu-component class="actions" :actions="actions(item)" /></td>
        <td>{{item.externalId}}</td>
        <td>{{$momentFormat(item.formed, "DD.MM.YYYY HH:mm")}}</td>
        <td>{{item.docNum}}</td>
        <td>{{$momentFormat(item.docDate, "DD.MM.YYYY")}}</td>
        <td>{{$momentFormat(item.docValidTo, "DD.MM.YYYY")}}</td>
        <td>
          <file-download :file="item.file"/>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  </section>
  <section class='modals'>
    <modal-component v-if="modals.import" title="Импорт ИПРА" size-class=""
                     @close="modals.import = false">
      <import-ipra v-on:doimport="doImport" @close="modals.import = false"/>
    </modal-component>
  </section>
  <div class="card-footer mt-5">
      <div class="d-flex align-items-center float-right">
        <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
      </div>
  </div>    
</template>

<script>
import API from "../api/ipra";
import Constants from "@/common/constants";
import EmptyListMessage from "../../../common/components/EmptyListMessage";
import ButtonComponent from "../../../common/ui/ButtonComponent";
import ModalComponent from "../../../common/ui/ModalComponent";
import ImportIpra from "./ImportIpra";
import MenuComponent from "../../../common/ui/components/page/MenuComponent";
import FileDownload from "../../../common/components/FileDownload";

export default {
  name: "Ipra",
  components: {FileDownload, MenuComponent, ImportIpra, ModalComponent, ButtonComponent, EmptyListMessage},
  props: {
    journalId: {
      type: Number,
      required: true
    },
    isReadonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      discharges: [],
      modals: {
        import: false
      }
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    actions(item) {
      let result = [{
        title: 'Просмотр',
        icon: 'eye',
        click: () => this.viewCard(item.id)
      }];
      if (!this.isReadonly) {
        result.push({
          title: 'Редактировать',
          icon: 'pen',
          click: () => this.editCard(item.id)
        });
        result.push({
          title: 'Удалить',
          icon: 'trash',
          click: () => this.deleteCard(item.id)
        });
      }
      return result;
    },
    loadList() {
      API.listForJournal(this.journalId)
          .then((response) => {
            this.discharges = response.data;
          });
    },
    addCard() {
      this.$router.push({ name: "ipraCard", params: { journal_id: this.journalId, action: 'add' } });
    },
    viewCard(id) {
      this.$router.push({ name: "ipraCard", params: { journal_id: this.journalId, action: 'view', id: id } });
    },
    editCard(id) {
      this.$router.push({ name: "ipraCard", params: { journal_id: this.journalId, action: 'edit', id: id } });
    },
    deleteCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id)
              .then(() => {
                this.loadList();
              })
              .catch(() => {
            Constants.alert.fire('Удаление', Constants.commonError, 'error');
          });
        }
      });
    },
    importXml() {
      this.modals.import = true;
    },
    doImport(file) {
      this.modals.import = false;
      API.import(this.journalId, file)
          .then((response) => {
            if (response.data.success) {
              Constants.alert.fire('Импорт', response.data.message, 'success');
              this.loadList();
            } else {
              Constants.alert.fire('Импорт', response.data.message, 'error');
            }
          });
    },
    close() {
      this.$router.push({name: 'Journal', query: { page1: this.$route.query.page1 }});
    },      
  }
}
</script>

<style scoped>
.card-footer{
    padding: 0;
    background-color: transparent;
    border: none;
}
</style>